import { render, staticRenderFns } from "./apiPermission.vue?vue&type=template&id=05307d8f&scoped=true&"
import script from "./apiPermission.vue?vue&type=script&lang=js&"
export * from "./apiPermission.vue?vue&type=script&lang=js&"
import style0 from "./apiPermission.vue?vue&type=style&index=0&id=05307d8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05307d8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05307d8f')) {
      api.createRecord('05307d8f', component.options)
    } else {
      api.reload('05307d8f', component.options)
    }
    module.hot.accept("./apiPermission.vue?vue&type=template&id=05307d8f&scoped=true&", function () {
      api.rerender('05307d8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/menu/apiPermission.vue"
export default component.exports